import { useHasUserValidPermissionProjectLevel } from "@hooks/permission-control/use-has-user-valid-permission-project-level";
import { shouldDisplayMarkupsForViewersSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { RequiredPermissionProjectLevelName } from "@utils/permission-control/project-permission-control-types";

/** Returns the permission required to view the selected project markups, e.g. in the annotations tab */
export function useProjectMarkupsPermissionName() {
  const shouldDisplayMarkupsForViewers = useAppSelector(shouldDisplayMarkupsForViewersSelector);
  return shouldDisplayMarkupsForViewers ? RequiredPermissionProjectLevelName.canViewProjectMarkupsAllowViewers : RequiredPermissionProjectLevelName.canViewProjectMarkups;
}

/** Returns whether the user can view the selected project markups, same condition as for the annotations tab */
export function useCanViewProjectMarkups() {
  const permissionName = useProjectMarkupsPermissionName();
  const permissions = useHasUserValidPermissionProjectLevel();
  return permissions[permissionName];
}